import { ItineraryFragment } from 'generated/graphql';

type SemweekDayFilterCollectorReturnType = {
  add: (itinerary: ItineraryFragment) => void;
  build: () => { departureDays: Set<number>; arrivalDays: Set<number> };
};
const SemweekDayFilterCollector = (): SemweekDayFilterCollectorReturnType => {
  const departureDays: Set<number> = new Set();
  const arrivalDays: Set<number> = new Set();

  return {
    add(itinerary: ItineraryFragment): void {
      const departureDay = new Date(
        itinerary.legs?.[0].segments[0].sections[0].departureDate as string
      ).getDay();
      departureDays.add(departureDay);
      if (itinerary.legs?.[1]) {
        const arrivalDay = new Date(
          itinerary.legs[1]?.segments[0].sections[0].arrivalDate
        )?.getDay();
        if (arrivalDay) arrivalDays.add(arrivalDay);
      }
    },
    build() {
      return {
        departureDays,
        arrivalDays,
      };
    },
  };
};

export default SemweekDayFilterCollector;
